import { faUsers } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const UsersIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faUsers} color={props.color} />
  )
}
